module.exports = __webpack_public_path__ + "img/employer_expectations.c39c7741.png";